module.exports = __webpack_public_path__ + "img/logo-but-small.56d390c0.png";